<template>

<div>
       <v-row no-gutters>
      <base-header>
        <div slot="page-header">Heat Map</div>
      </base-header>
    </v-row>

 <v-row no-gutters>
    <card-slider></card-slider>
    </v-row>
        <v-row no-gutters>
           
                       <v-col cols="12" lg="12" xl="12">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                    <chart-heatmap></chart-heatmap>
                    </div>
                </base-card>
            </v-col>
           
        </v-row>
       
    <v-row no-gutters>
<v-col cols="12" lg="12" xl="12">
        <card-tab></card-tab>
      </v-col>
    </v-row>
       
</div>
</template>

<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
    import BaseHeader from "../../components/Base/BaseHeader.vue";
  import ChartHeatmap from '../../components/Charts/ChartHeatmap'
    import CardSlider from '../../components/Cards/CardSlider'

  import CardTab from '../../components/Cards/CardTab'

    export default {
        components: {
            BaseCard,
            BaseHeader,
           ChartHeatmap,CardSlider,
          CardTab

        },
    }
</script>